export class Credential {
    mobile: string
    password: string
    
    constructor(mobile: string, password: string) {
        this.mobile = mobile
        this.password = password
    }
}

//SCMT 2.0
// 17-07-2024 NewCredential funtion start

export class NewCredential {
    mobile : string

    constructor(mobile: string) {
        this.mobile = mobile
    }
}

// NewCredential funtion end